export default __webpack_public_path__ + "static/media/logo-ridradio.0c7db35e.svg";